export class BrowserSupportService {
  constructor(private window: Window & typeof globalThis) {}

  isSupported(): boolean {
    return this.supportsCssVariables() && this.supportsGlobalThis();
  }

  private supportsCssVariables(): boolean {
    if (this.window.CSS && this.window.CSS.supports('color', 'var(--test-var)')) {
      return true;
    } else {
      return false;
    }
  }

  private supportsGlobalThis(): boolean {
    return typeof globalThis === 'object';
  }

  showNotSupportedWindow(staticPagesUrl: string): boolean {
    const width = 438;
    const height = 402;
    const windowTop = this.window.top;
    const y = windowTop ? windowTop.outerHeight / 2 + windowTop.screenY - height / 2 : 0;
    const x = windowTop ? windowTop.outerWidth / 2 + windowTop.screenX - width / 2 : 0;

    const userLang = (navigator.language || window.navigator.language).toLowerCase();
    const lang = userLang.includes('de') ? 'de' : 'en';
    const url = `${staticPagesUrl}/${lang}/web-checkout/browser-not-supported/${this.isIE() ? 'ie' : 'other'}`;
    this.window.open(
      url,
      '',
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${y}, left=${x}`
    );
    return false;
  }

  private isIE(): boolean {
    return /msie\s|trident\//i.test(this.window.navigator.userAgent);
  }
}
